import {useContext} from "react"
import {NotificationActionContext, NotificationContext} from "./context"

export function useContentCards() {
  const context = useContext(NotificationContext)
  if (!context) throw new Error("useContentCards must be used inside of a ContentCardProvider")

  return context
}

export function useContentCardActions() {
  const context = useContext(NotificationActionContext)
  if (!context) throw new Error("useContentCardActions must be used inside of a ContentCardProvider")

  return context
}
